import { useEffect, useState } from "react";
import { fetchMetaData } from "@api/procurements/metaData";

export const useMetaData = (moduleName: string) => {
  const [resData, setResData] = useState<any>([]);

  useEffect(() => {
    fetchMetaData(moduleName)
      .then((data) => setResData(data.data))
      .catch((err) => console.log(err));
  }, [moduleName]);

  return {
    resData,
  };
};
